import CompanyClientsDetails from './CompanyClientsDetails';

export default CompanyClientsDetails;
